export default __webpack_public_path__ + "static/media/master-grid.d86405c3.png";